import React, { useState, useRef, useEffect } from 'react';
import UserManagementSearchbar from '../../Pages/User Management/userManagementSearchbar';
import SearchBar from './SearchBar';

// import img from "../../assets/PortalIconnographySVGs/PortalAppRealted_Icons/Power Search/__Search.svg";

import classes from './PowerSearch.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { PowerSearch, UserPowerSearch } from '../../Api Methods/Api';
import DataManager from '../../hooks/DataManager';
import postRequest from '../../Api Methods/Request Methods/postRequest';
import AllSitesSearchBar from '../../Pages/AllSites/allSitesSearchBar';

const FilterUsersSearch = ({ searchQuery, setSearchQuery, setIsLoading, placeholder, setFilteredResults, handleFilterLogic, categories, reset, setReset, portalAdmin, setPortalAdmin, appAdmin, setAppAdmin, pageSize, setPageSize, pageOffset, setPageOffset, disableInternalFetch, externalResultCount }) => {
    const dispatch = useDispatch();
    const [categoryFilter, setCategoryFilter] = useState([]);
    const dataManager = new DataManager()
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const [resultCount, setResultCount] = useState(0)

    const ApiData = {
        token,
        client
    }

    const formRef = useRef();

    const timer = useRef();

    /*const type = [
        "Portal admin",
        "App admin",
        "Standard user",
    ] */


    useEffect(() => {
        if (disableInternalFetch) return;

        const HandleUserSearch = async (ApiData, query) => {

            let body = {
                "query": query,
                "portalAdmin": portalAdmin,
                "appAdmin": appAdmin,
                "pageSize": pageSize,
                "pageOffset": pageOffset
            }
            
            timer.current = Date.now();
            const triggerTime = timer.current;
            const responseData = await UserPowerSearch(ApiData, body, dispatch);
            const users = responseData[0].users;
            setResultCount(responseData[0].totalCount.resultCount)
            if (timer.current == triggerTime) {
                handleFilterLogic(users, searchQuery, categoryFilter);
                
                if (users != null) {
                    //setIsLoading(false);
                }
            }

        }

        const delayDebounceFn = setTimeout(() => {
            //   Perform fetch call with the input value
            if (searchQuery !== "") {
                //setIsLoading(true)
                dataManager.setItem('userSearchQuery', searchQuery)
                HandleUserSearch(ApiData, searchQuery)
            } else if (dataManager.getItem('userSearchQuery') == ""){
                setReset(reset+1)
                setResultCount(0)
            }
        }, 1700);


        return () => clearTimeout(delayDebounceFn);
    }, [searchQuery, categoryFilter, appAdmin, portalAdmin, disableInternalFetch]);


    return (
        <form className={classes.form} ref={formRef} onSubmit={(e) => e.preventDefault()}>
            <div className={classes.searchContainer}>
                {/* 
                <UserManagementSearchbar
                    placeholder={placeholder}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                    setCategoryFilter={setCategoryFilter}
                    showFilterButton={true}
                    reset={reset}
                    appAdmin={appAdmin}
                    setAppAdmin={setAppAdmin}
                    portalAdmin={portalAdmin}
                    setPortalAdmin={setPortalAdmin}
                />   
                */}
                <AllSitesSearchBar 
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    showFilterButton={true}
                    showUserFilters={true}
                    appAdmin={appAdmin} setAppAdmin={setAppAdmin}
                    portalAdmin={portalAdmin} setPortalAdmin={setPortalAdmin}
                    style={{
                        padding: "10px",
                        width: "300px",
                        boxSizing: "border-box",
                        borderRadius: "4px",
                    }}
                />         
            </div>
            
        </form>
    );
};

export default FilterUsersSearch;
